<template>
  <div
    class="mt-1"
  >
    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <span style="font-size:20px; color: #fff;">ตารางสรุปปริมาณรถในสายทางแต่ละจุด</span>
      </b-col>
      <b-col cols="12">
        <b-table
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template
            slot="thead-top"
          >
            <th
              colspan="1"
              style="text-align:center;font-size: 14px"
            />
          </template>
          <!-- <template
            slot="head(camid)"
          >
            <b-th
              style="text-align:center;font-size: 12px"
            >
              กล้องที่
            </b-th>
          </template> -->
          <template
            slot="thead-top"
          >
            <th
              colspan="8"
              style="text-align:center;font-size: 14px; background:rgb(0,0,0, 0.6); color: #fff;"
            >
              ประเภทรถ
            </th>
          </template>
          <!-- <template
            slot="thead-top"
          >
            <th
              colspan="8"
              style="text-align:center;font-size: 14px; background:rgb(0,0,0, 0.4); color: #fff;"
            >
              PCU
            </th>
          </template> -->
          <template
            slot="thead-top"
          >
            <th
              colspan="2"
              style="text-align:center;font-size: 14px"
            />
          </template>
          <template #cell(Bike)="data">
            {{ data.item.Bike.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </template>
          <template #cell(Car)="data">
            {{ data.item.Car.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </template>
          <template #cell(Truck)="data">
            {{ data.item.Truck.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </template>
          <template #cell(Bus)="data">
            {{ data.item.Bus.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </template>
          <template #cell(Taxi)="data">
            {{ data.item.Taxi.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </template>
          <template #cell(Pickup)="data">
            {{ data.item.Pickup.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </template>
          <template #cell(Trailer)="data">
            {{ data.item.Trailer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </template>
          <template #cell(Total)="data">
            {{ data.item.Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </template>
          <template #cell(camconnect)="data">
            <b-badge :variant="camconnect[1][data.value]">
              {{ camconnect[0][data.value] }}
            </b-badge>
          </template>
          <template #cell(formula)="data">
            <b-link
              v-b-modal="'Formula'"
              @click="$refs.formula.getFormulaPopup(data.item.camid), title(data.item.Camera_Desc)"
            ><feather-icon
              class="text-info"
              icon="TrelloIcon"
              size="20"
            />
            </b-link>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <template>
      <!-- MODAL ProblemEdit -->
      <CardPopUpCountingFormula
        ref="formula"
        :title="titleName"
      />
    </template>
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BLink,
  BBadge,
} from 'bootstrap-vue'
import axios from '@axios'
import CardPopUpCountingFormula from './CardPopUpCountingFormula.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    // BTh,
    // BImg,
    BBadge,
    BLink,
    CardPopUpCountingFormula,
  },
  data() {
    return {
      fields: [
        {
          key: 'camid',
          label: 'กล้องที่',
          class: 'text-center',
        },
        {
          key: 'Bike',
          label: 'จักรยานยนต์',
          class: 'text-center',
        },
        {
          key: 'Car',
          label: 'รถยนต์',
          class: 'text-center',
        },
        {
          key: 'Truck',
          label: 'รถบรรทุก',
          class: 'text-center',
        },
        {
          key: 'Bus',
          label: 'รถบัส',
          class: 'text-center',
        },
        {
          key: 'Taxi',
          label: 'รถแท็กซี่',
          class: 'text-center',
        },
        {
          key: 'Pickup',
          label: 'รถกระบะ',
          class: 'text-center',
        },
        {
          key: 'Trailer',
          label: 'รถพ่วง',
          class: 'text-center',
        },
        {
          key: 'Total',
          label: 'ทั้งหมด',
          class: 'text-center',
        },
        {
          key: 'camconnect',
          label: 'สถานะ',
          class: 'text-center',
        },
        {
          key: 'Camera_Desc',
          label: 'ตำแหน่งกล้อง',
          class: 'text-center',
        },
        // {
        //   key: 'formula',
        //   label: 'ข้อมูลการคำนวณ',
        //   class: 'text-center',
        // },
      ],
      items: [],
      perPage: 25,
      pageOptions: [25, 50, 75, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      camconnect: [{
        Online: 'ออนไลน์', Offline: 'ออฟไลน์',
      },
      {
        Online: 'success', Offline: 'danger',
      }],
      titleName: '',
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      // If the user IS an admin, return all fields.
      return this.fieldsSpeaker
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getTableCount()
    this.interval = setInterval(() => {
      this.getTableCount()
    }, 300000)
  },
  methods: {
    getTableCount() {
      axios
        .post('/getTableCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
        .catch(error => {
          console.log(error)
        })
    },
    title(value) {
      this.titleName = value
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
  .vue2leaflet-map {
    &.leaflet-container{
      position: absolute;
      width: 1454px;
      height: 568px;
    }
  }
  // .leaflet-container a.leaflet-popup-close-button {
  //   padding: 0 0 0 0
  // }
</style>
